import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import Vue from "vue";
export default Vue.extend({
  name: "ManagerShare",
  components: {},
  data: function data() {
    return {
      label: "课件",
      pageSize: 8,
      pageIndex: 1,
      totalCount: 0,
      name: "source",
      list: [],
      nodePathList: [],
      courseName: "22",
      dataCount: 1,
      folderId: "",
      sourceIds: [],
      checkedList: [],
      disabled: false,
      checkStatus: false,
      activeName: "school",
      xzdis: false,
      tab: true,
      impCourseId: ""
    };
  },
  props: {
    courseId: {
      type: String,
      default: ""
    },
    activityIds: {},
    IsState: {
      type: Number,
      default: 0
    },
    setData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    CreatedSchoolId: {
      type: String,
      default: ""
    },
    lable: {
      type: String,
      default: ""
    },
    CouIsChoice: {
      type: String,
      default: ""
    },
    // 资源类型 0 课件 ,1 题目 , 2 作业 , 3 目录  ,4 互动
    type: {
      type: Number,
      default: 0
    },
    activityType: {
      type: String,
      default: ""
    },
    childGet: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.getSourceList("source", 1);
  },
  watch: {
    setData: function setData(val) {
      this.$emit('update:ids', val); // this.$emit("update:courseId", this.courseId);

      if (this.setData.length > 0) {
        this.xzdis = true;
      } else {
        this.xzdis = false;
      }
    },
    impCourseId: function impCourseId(val) {
      this.$emit('update:impCourseId', val);
    },
    IsState: function IsState() {
      this.$emit('update:IsState', this.IsState);
    },
    checkData: function checkData(val) {
      var checkLength = this.list.length;

      for (var i = 0; i < checkLength; i++) {
        if (this.list[i].checked) {
          if (this.list[i].checked == true) {
            this.list[i].chec1ked = false;
          }
        }
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('update:IsState', Math.random());
    },
    getSourceList: function getSourceList(type, page) {
      var _this = this;

      this.$nextTick(function () {
        GetSourceList(_this.courseId, _this.folderId, type, page).then(function (rst) {
          if (rst.code > 0) {
            _this.list = rst.list;
            _this.totalCount = rst.pagination.totalCount;
            _this.pageSize = rst.pagination.pageSize;
            _this.courseName = rst.courseName;
            _this.nodePathList = rst.nodePathList;
            _this.dataCount = rst.dataCount;
            rst.list.forEach(function (item) {
              _this.$set(_this.checkedList, item.Id, false);
            });
          } else {
            return;
          }
        });
      });
    },
    // getResources(n){
    //   console.log(n);
    // }
    // ManagerGetmsg(val){
    //   this.$emit('judgeBtn',val)
    // },
    mangerBtnMsg: function mangerBtnMsg(val) {
      this.$emit('dialogBtn', val);
    },
    mangerPatnerBtnMsg: function mangerPatnerBtnMsg(val) {
      this.$emit('dialogrPatnerBtn', val);
    },
    handleClick: function handleClick(tab, event) {
      this.$emit('tabClick', tab.index);
    },
    closeDialog: function closeDialog() {
      this.$emit('closeDialog');
    }
  }
});